import { useState } from "react";
import { Button } from "@/components/ui/button";
import logoIcon from "@/assets/logo-icon.jpg";
import { ArrowRight } from "lucide-react";
import WaitlistModal from "./WaitlistModal";

const Footer = () => {
  const [waitlistModalOpen, setWaitlistModalOpen] = useState(false);

  return (
    <>
      <footer className="bg-muted/50 border-t border-border">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src={logoIcon} 
                  alt="Airing Down Logo" 
                  className="w-10 h-10 rounded-lg"
                />
                <div>
                  <h3 className="text-xl font-bold text-foreground">Airing Down</h3>
                  <p className="text-sm text-muted-foreground">Off-Road Adventures, Mapped</p>
                </div>
              </div>
              <p className="text-muted-foreground mb-4 max-w-md">
                The community platform for off-road adventurers. Research trails, track your adventures, 
                share your stories, and inspire others to get outdoors.
              </p>
              <p className="text-sm text-muted-foreground mb-6">
                Starting in Southern California - Expanding Nationwide
              </p>

              {/* Email Capture */}
              <div className="max-w-sm">
                <p className="text-sm font-medium text-foreground mb-2">Stay in the loop</p>
                <div className="flex gap-2">
                  <Button 
                    variant="outline" 
                    className="flex-1"
                    onClick={() => setWaitlistModalOpen(true)}
                  >
                    Join the Waitlist
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </div>
              </div>
            </div>

            {/* Features */}
            <div>
              <h4 className="font-semibold text-foreground mb-4">Features</h4>
              <ul className="space-y-2">
                <li><span className="text-muted-foreground">Trail Discovery</span></li>
                <li><span className="text-muted-foreground">GPX Upload</span></li>
                <li><span className="text-muted-foreground">Condition Reports</span></li>
                <li><span className="text-muted-foreground">Achievements</span></li>
                <li><span className="text-muted-foreground">Community</span></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-semibold text-foreground mb-4">Support</h4>
              <ul className="space-y-2">
                <li><a href="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact Us</a></li>
                <li><a href="/feedback" className="text-muted-foreground hover:text-primary transition-colors">Beta Feedback</a></li>
                <li><a href="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</a></li>
                <li><a href="/terms" className="text-muted-foreground hover:text-primary transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-sm">
              © 2025 Airing Down. All rights reserved.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              <span className="text-sm text-muted-foreground">Follow Us:</span>
              <a 
                href="https://instagram.com/airing_down" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Follow us on Instagram"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
                </svg>
              </a>
              <a 
                href="https://tiktok.com/@airing.down" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Follow us on TikTok"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Waitlist Modal */}
      <WaitlistModal 
        open={waitlistModalOpen} 
        onOpenChange={setWaitlistModalOpen} 
      />
    </>
  );
};

export default Footer;
